var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHighSupportFoundations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3388_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0861 35.4859H4.9291C2.22114 35.4859 0 33.2757 0 30.5811V20.8017C0 18.1071 2.22114 15.8969 4.9291 15.8969H51.0861C53.7941 15.8969 56.0152 18.1071 56.0152 20.8017V30.5811C55.9848 33.306 53.7941 35.4859 51.0861 35.4859ZM4.04673 18.1677C3.1035 18.1677 2.34284 19.0154 2.34284 20.0448V31.3683C2.34284 32.3977 3.1035 33.2454 4.04673 33.2454H51.9381C52.8813 33.2454 53.6419 32.3977 53.6419 31.3683V20.0448C53.6419 19.0154 52.8813 18.1677 51.9381 18.1677H4.04673Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 30H9V21H11V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 30H15V21H17V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 30H21V21H23V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 30H27V21H29V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 30H33V21H35V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 30H39V21H41V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 30H45V21H47V30Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9848 53.9849H46.157V47.4451H9.82776V53.9849H0V40.1485C0 38.7558 1.12578 37.6355 2.5254 37.6355H53.4898C54.8894 37.6355 56.0152 38.7558 56.0152 40.1485V53.9849H55.9848Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1188 0H26.6543V7.3345H29.1188V0Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8701 2.39435L34.4297 8.75241L36.5997 9.91509L40.0401 3.55704L37.8701 2.39435Z",
    fill: "#233638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3224 2.39774L15.1523 3.56042L18.5928 9.91848L20.7628 8.7558L17.3224 2.39774Z",
    fill: "#233638"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3388_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighSupportFoundations);
export default __webpack_public_path__ + "static/media/iconHighSupportFoundations.1701fcf917f308b8edfc2e2785624286.svg";
export { ForwardRef as ReactComponent };